import React from 'react';

const categories = ["breakfast", "lunch", "dinner", "drinks", "sweets", "cakes"];

const Nav = ({ current, setCurrent }) => {
    return (
        <nav className="bg-white p-4 shadow-md sticky top-0 z-10 rounded-b-lg">
            <div className="container mx-auto flex flex-wrap justify-center gap-3">
                {categories.map(category => (
                    <button
                        key={category}
                        onClick={() => setCurrent(category)}
                        className={`category-btn px-4 py-2 rounded-full font-semibold transition duration-300 shadow-md ${current === category
                                ? 'bg-orange-500 text-white'
                                : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                            }`}
                    >
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                    </button>
                ))}
            </div>
        </nav>
    );
};

export default Nav;